// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3732": "64ef5eef","4430": "5c9d838d","4520": "ca7d58f4","5240": "ba46cadb","5545": "976c794a","7330": "022e8365","7755": "dd9d9c7b",}[chunkId] + ".css"
}